module.exports = __webpack_public_path__ + "static/img/zf.ad94601.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/safes/zf.png
// module id = s2RT
// module chunks = 0